;
// <script src="{{ '_action26_channel_source_injector.js' | asset_url }}" defer></script>
(function() {
    /**
     * 获取渠道标识
     */
    const channelValue = (function() {
      // DreameApp
      if(typeof window.flutter_inappwebview !== 'undefined'){
        return "dreame";  
      }
      // const url = new URL(window.location.href);
      // if('_dreame' === url.searchParams.get('_dreame')){
      //   return "dreame";
      // }

      return "default";
    })();
 
    console.log('_channel_value_='+channelValue)

    // if(channelValue == 'dreame'){
    //   (function createTestDot() {
    //     const dot = document.createElement('div');
    //     dot.style.cssText = `
    //       width: 4px;
    //       height: 4px;
    //       background: red;
    //       position: fixed;
    //       top: 0;
    //       right: 0;
    //       z-index: 999999;
    //       pointer-events: none;
    //     `;
    //     document.body.appendChild(dot);
    //   })();
    // }

    if(!channelValue || channelValue=='default'){
      return false;
    }


  // 购物车
  // if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart'))
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          "app_user": channelValue
        },
      }),
    });

    /**
     * 向一个表单注入 hidden input: properties[channel]
     */
    function injectChannelIntoForm(form, channelValue) {
      if (!form || !channelValue) return;
      // 已经有 properties[app_user] 就不重复加
      var input = form.querySelector('input[name="properties[app_user]"]');
      if (input) {
        input.value = channelValue;
      }else{
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[app_user]";
        input.value = channelValue;
        form.appendChild(input);
      }
    }

    /**
     * 查找所有商品相关的表单，并注入 channel
     */
    function injectChannelIntoAllProductForms() {
      if (!channelValue) return;

      // 选择器说明：
      // - form[action*="/cart/add"]: 绝大部分主题的加购/Buy it now 表单
      // - 如有特殊 data-attribute，也可以一起加进来
      var selectors = [
        'form[action*="/cart/add"]',
        'form[action*="/cart/add.js"]'
      ];

      var forms = document.querySelectorAll(selectors.join(","));
      if (!forms || forms.length === 0) {
        return;
      }

      forms.forEach(function (form) {
        injectChannelIntoForm(form, channelValue);
      });
    }

    /**
     * 初始执行：DOM 加载完成后跑一遍
     */
    function onReady(fn) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", fn);
      } else {
        fn();
      }
    }

    onReady(function () {
      try {
        injectChannelIntoAllProductForms();
      } catch (e) {
        console.error("[action26_channel_source_injector] Failed to initialize：", e);
      }
    });

    /**
     * 如果主题会通过 AJAX/Section Rendering 动态插入商品表单，
     * 可以用 MutationObserver 监听 DOM 变化，给之后加载的 form 再补一次。
     */
    try {
      var observer = new MutationObserver(function (mutations) {
        var needReinject = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === "childList" && m.addedNodes && m.addedNodes.length > 0) {
            needReinject = true;
            break;
          }
        }
        if (needReinject) {
          injectChannelIntoAllProductForms();
        }
      });
      observer.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      console.warn("[action26_channel_source_injector] Failed to initialize MutationObserver：", e);
    }
})();